import { createLocalStorageManager, LocalStore } from 'shared/helpers/Store';
import { OnboardingStep } from './OnboardingDTO';

export const ONBOARDING_STEP = 'onboarding_step';

export function onboardingStepStorageKey(guid: string): string {
  return `${ONBOARDING_STEP}:${guid}`;
}

export function getOnboardingStepStore(guid: string) {
  return createLocalStorageManager<OnboardingStep>(
    onboardingStepStorageKey(guid),
  );
}

export function ignoreFlatOnboardingStepCache(): void {
  LocalStore.delete(ONBOARDING_STEP);
}

export function readOnboardingStep(guid: string): OnboardingStep | undefined {
  ignoreFlatOnboardingStepCache();

  if (!guid) {
    return undefined;
  }

  return getOnboardingStepStore(guid).get();
}

export function persistOnboardingStep(
  guid: string,
  data: OnboardingStep,
  expires: number,
): void {
  ignoreFlatOnboardingStepCache();

  if (!guid) {
    return;
  }

  getOnboardingStepStore(guid).set(data, expires);
}

export function deleteOnboardingStepCache(guid?: string): void {
  ignoreFlatOnboardingStepCache();

  if (guid) {
    getOnboardingStepStore(guid).delete();
  }
}
